import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IcosClassDirective } from './directives'
import { ExDynamicService, DocumentWrapper, WindowWrapper } from '../shared/services'
import { IcosCSSValuePipe } from './pipe'
export function getDocument(): any { return document }
export function getWindow(): any { return window }

@NgModule({
  declarations: [
    IcosCSSValuePipe,
    IcosClassDirective,
  ],
  exports: [
    IcosCSSValuePipe,
    IcosClassDirective,
  ],
  imports: [CommonModule],
  entryComponents: [],
})
export class IcosSharedModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosSharedModule, providers: [
      ExDynamicService,
        IcosCSSValuePipe,
      { provide: DocumentWrapper, useFactory: getDocument },
      { provide: WindowWrapper, useFactory: getWindow },
    ]}
  }
}
